module.exports = __webpack_public_path__ + "assets/android-chrome-512x512.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/android-chrome-512x512.png
// module id = 929
// module chunks = 17